
import { Vue } from "vue-class-component";

export default class Track extends Vue {}
